import React from 'react'
import { makeStyles } from '@material-ui/core'
import statsNavBarStyles from './statsNavBar.styles'
import { useTranslate } from 'react-admin'
import ConditionalRender from '../../components/ConditionalRender/ConditionalRender'
import isSelectedOrgCompetitionOrFederation from '../../utils/helpers/isSelectedOrgCompetitionOrFederation'

const StatsNavBar = ({ currentTab, setCurrentTab }) => {
  const translate = useTranslate(statsNavBarStyles)
  const useStyles = makeStyles(statsNavBarStyles)
  const classes = useStyles()

  return (
    <div className={classes.navBar}>
      <div
        className={`${classes.tab} ${currentTab === 'stats' ? classes.activeTab : ''}`}
        onClick={() => setCurrentTab('stats')}
      >
        {translate('ra.text.stats')}
      </div>
      <div
        className={`${classes.tab} ${currentTab === 'games' ? classes.activeTab : ''}`}
        onClick={() => setCurrentTab('games')}
      >
        {translate('ra.text.navGames')}
      </div>
      <ConditionalRender renderValue={isSelectedOrgCompetitionOrFederation()}>
        <div
          className={`${classes.tab} ${currentTab === 'players' ? classes.activeTab : ''}`}
          onClick={() => setCurrentTab('players')}
        >
          {translate('ra.text.playersSmall')}
        </div>
      </ConditionalRender>
    </div>
  )
}

export default StatsNavBar
